import { createSlice } from '@reduxjs/toolkit'
import { Slice } from './types'
import { ACCOUNT_MANAGEMENT } from 'lib/core/resources/constants'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false
}

const slice = createSlice({
  name: 'customer/resetPasswordEmail',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

interface ResetPasswordEmailDeps {
  email: string
}

export function resetPasswordEmail (data: ResetPasswordEmailDeps): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())

    try {
      const state = getState()
      const websiteId = state.common.storeConfig.payload?.website_id as number
      const payload = {
        websiteId,
        template: ACCOUNT_MANAGEMENT.EMAIL_RESET,
        ...data
      }
      await magentoClient.getClient().customer.resetPasswordEmail({ payload })
      dispatch(success())
    } catch (e) {
      dispatch(failure())
    }
  }
}
